import React from "react";
import { Link } from "react-router-dom";
import content from "../content/content.json";

const RiskCapitalSection = () => {
  const { riskCapitalSection, shared } = content;

  return (
    <div className="w-full bg-[#F8FAFB] mt-8">
      {riskCapitalSection.entries.map((entry, index) => (
        <section
          key={`${entry.title}-${index}`}
          className={`py-24 px-6 md:px-20 flex flex-col ${
            index === 1 ? "md:flex-row-reverse" : "md:flex-row"
          } items-center justify-between gap-5`}
        >
          <div className="w-full md:w-1/2 text-left">
            <h4 className="text-[#007681] font-semibold mb-3">{entry.eyebrow}</h4>

            <h2 className="text-5xl font-extrabold text-[#1C1F2B] mb-4">{entry.title}</h2>

            <h3 className="text-2xl text-[#1C1F2B] font-medium mb-6">{entry.subtitle}</h3>

            <p className="text-gray-600 leading-relaxed text-lg mb-10 whitespace-pre-line">{entry.description}</p>

            <Link to={index === 0 ? "/framework#integrity" : "/framework#delivery"} className="learn-more-btn group relative overflow-hidden bg-[#E4002B] border border-[#E4002B] px-8 py-4 font-semibold rounded-none flex items-center gap-2 w-[30%] justify-center">
              <span className="relative z-10 text-white group-hover:text-[#E4002B] transition-colors duration-300">
                {entry.button}
              </span>
              <span className="relative z-10 text-white text-xl group-hover:text-[#E4002B] transition-colors duration-300">
                {shared.arrow}
              </span>
            </Link>
          </div>

          <div className={`w-full md:w-1/2 flex justify-center ${index === 1 ? "md:justify-start" : "md:justify-end"}`}>
            <img src={entry.image} alt={entry.imageAlt} className="w-full md:w-[85%] rounded-sm object-cover" />
          </div>
        </section>
      ))}
    </div>
  );
};

export default RiskCapitalSection;

